const MegaMenuResultTemplates = {};

MegaMenuResultTemplates.KontentItemArticleDonorArea = require("./items/megaMenuResultDonorArea").default;
MegaMenuResultTemplates.KontentItemArticlePageLearn = require("./items/megaMenuResultLearn").default;
MegaMenuResultTemplates.KontentItemProgram = require("./items/megaMenuResultProgram").default;
MegaMenuResultTemplates.KontentItemTargetGroupPage = require("./items/megaMenuResultTargetGroupPage").default;

export default MegaMenuResultTemplates;
